// app/javascript/controllers/react_controller.ts

import { Controller } from "@hotwired/stimulus"
import React from "react"
import { createRoot, Root } from "react-dom/client"
import StockList from "../components/StockList"
import StockDetail from "../components/StockDetail"

const COMPONENTS: Record<string, React.ComponentType<any>> = {
  StockList,
  StockDetail
}

export default class extends Controller<HTMLDivElement> {
  static values = {
    component: String,
    props: Object
  }

  declare componentValue: keyof typeof COMPONENTS
  declare propsValue: Record<string, unknown>
  root?: Root

  connect() {
    const Component = COMPONENTS[this.componentValue] as React.ComponentType<any>

    if (!Component) {
      console.error(`Component ${this.componentValue} not found!`)
      return
    }

    this.root = createRoot(this.element)
    this.root.render(React.createElement(Component, this.propsValue))
  }

  disconnect() {
    if (this.root) {
      this.root.unmount()
    }
  }
}
